export default function PageHeader({ title, subtitle }) {
  return (
    <div className="mb-8">
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="text-lumora-text/60 text-sm mt-1">{subtitle}</p>}
    </div>
  );
}
